<template>
	<GmapCustomMarker
		:marker="{
			lat: plantioMarker.infoPoligono.centroId.coordinates[1],
			lng: plantioMarker.infoPoligono.centroId.coordinates[0],
		}"
		:z-index="zIndex"
	>
		<div
			class="container__plantiomarker"
			:class="{ open: isOpenCard }"
		>
			<div
				v-if="!isOpenCard"
				class="container__plantiomarker__close"
				@click.stop="toggleCard"
			>
				{{ plantioMarker.codigo }}
			</div>
			<div
				v-if="isOpenCard"
				class="container__plantiomarker__open"
			>
				<button
					class="button-x"
					@click="toggleCard"
				>
					<img
						src="@/assets/btn_x.png"
						alt="X"
						class="icon"
					/>
				</button>
				<div class="container__plantiomarker__open__title">
					<div style="display: flex; flex-direction: column; gap: 0.3rem">
						<span style="font-size: 0.7rem"> {{ $t('plantation') }} </span>
						<span>{{ plantioMarker.codigo }}</span>
					</div>
				</div>

				<div
					v-if="plantioMarker.codigoTalhao"
					class="container__plantiomarker__open__info"
				>
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('sectionCode') }}</span>

						<span>{{ plantioMarker.codigoTalhao }}</span>
					</div>
				</div>

				<div
					v-if="plantioMarker.infoPoligono.poligono"
					class="container__plantiomarker__open__info"
				>
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('plantationDate') }}</span>
						<span>{{
							new Date(
								plantioMarker.infoPoligono.poligono.properties['Data de Plantio'],
							).toLocaleDateString()
						}}</span>
					</div>
				</div>

				<div
					v-if="plantioMarker.estratoFlorestalContinuo"
					class="container__plantiomarker__open__info"
				>
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('estratoContinuo') }}</span>
						<span>{{ plantioMarker.estratoFlorestalContinuo }}</span>
					</div>

					<div class="container__plantiomarker__open__info__values right">
						<Checkbox @input="changeValue" />
					</div>
				</div>
				<div
					v-if="plantioMarker.estratosFlorestaisIPC && plantioMarker.estratosFlorestaisIPC.length"
					class="container__plantiomarker__open__info"
				>
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('estratoPreCorte') }}</span>
						<span
							v-for="ipc in plantioMarker.estratosFlorestaisIPC"
							:key="ipc"
							>{{ ipc }}</span
						>
					</div>

					<div class="container__plantiomarker__open__info__values right">
						<Checkbox @input="showEstratoPreCorte" />
					</div>
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('areaDoPlantio') }}</span>
						<span>
							{{ plantioMarker.area }} (ha)
							<span v-if="plantioMarker.areaDoTalhao">/ {{ plantioMarker.areaDoTalhao }} (ha)</span>
						</span>
						<span v-if="plantioMarker.areaDoTalhao">
							{{ plantioMarker.porcentagemDeAreaPlantadaNoTalhao }} {{ $t('areaDoTalhaoPlantada') }}
						</span>
					</div>
					<div
						v-if="plantioMarker.dapMedio"
						class="container__plantiomarker__open__info__values right"
						style="text-align: end"
					>
						<span>DAP Médio</span>
						<span> {{ plantioMarker.dapMedio.toFixed(2) }} cm</span>
					</div>
					<!-- <div class="container__plantiomarker__open__info__poligono">
           <PoligonoSvg :infoGeo="plantioMarker.infoPoligono" /> 
          </div> -->
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('spacing') }}</span>
						<span> {{ plantioMarker.espacamento }}</span>
					</div>
					<div
						v-if="plantioMarker.idade"
						class="container__plantiomarker__open__info__values right"
					>
						<span>{{ $t('idade') }}</span>
						<span> {{ plantioMarker.idade }} (anos) </span>
					</div>
					<div
						v-if="plantioMarker.volumeMedio"
						class="container__plantiomarker__open__info__values right"
					>
						<span>{{ $t('averageVolume') }}</span>
						<span> {{ plantioMarker.volumeMedio.toFixed(2) }} (m³/ha) </span>
					</div>
				</div>
				<div class="container__plantiomarker__open__info">
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('geneticMaterial') }}</span>
						<span> {{ plantioMarker.materialGenetico }}</span>
					</div>
					<div
						v-if="!!plantioMarker.intensidadeAmostral"
						class="container__plantiomarker__open__info__values right"
					>
						<span>{{ $t('intensidadeDaAmostra') }}</span>
						<span> 1 parcela/{{ plantioMarker.intensidadeAmostral.toFixed(2) }}ha </span>
					</div>
					<div
						v-if="plantioMarker.htMedio"
						class="container__plantiomarker__open__info__values right"
					>
						<span>HT Médio</span>
						<span> {{ plantioMarker.htMedio.toFixed(2) }} m </span>
					</div>
				</div>

				<div
					v-if="plantioMarker.customs && plantioMarker.customs.length"
					class="container__plantiomarker__open__info"
				>
					<div class="container__plantiomarker__open__info__values">
						<span>{{ $t('customVariables') }}</span>
						<div style="display: flex; gap: 0.8rem; padding: 0.8rem 0; flex-wrap: wrap">
							<Tag
								v-for="custom in plantioMarker.customs"
								:key="custom"
								:label="custom"
								class-name="default outlined"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</GmapCustomMarker>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import Checkbox from '../Checkbox/Checkbox'
import Tag from '../Tag/Tag'
// import PoligonoSvg from "../../../../../components/PoligonoSvg/PoligonoSvg";

export default {
	components: {
		GmapCustomMarker,
		Checkbox,
		Tag,
		//PoligonoSvg
	},
	props: {
		/**
		 * Informacoes do marker e do plantio que devem ser colocados no mapa
		 */
		plantioMarker: Object,
	},
	data: () => {
		return {
			/**
			 * Define o zIndex do marker
			 */
			isDebounced: false,
			zIndex: 50,
			isOpenCard: false,
		}
	},
	methods: {
		changeValue(e) {
			this.$emit('showEstratoContinuos', e)
		},
		showEstratoPreCorte(e) {
			this.$emit('showEstratoPreCorte', e)
		},
		toggleCard() {
			if (this.isDebounced) return // Impede a execução se já estiver em debounce

			this.isDebounced = true // Ativa o debounce
			this.isOpenCard = !this.isOpenCard
			this.zIndex = this.isOpenCard ? 60 : 50
			console.log('isOpenCard:', this.isOpenCard)
			// Define um tempo para liberar o clique novamente
			setTimeout(() => {
				this.isDebounced = false
			}, 300) // 300ms de debounce
		},
	},
}
</script>

<style scoped>
.container__plantiomarker {
	cursor: default;
	font-family: 'Open Sans', sans-serif;
	background-color: transparent;
}

.container__plantiomarker.open {
	background-color: white;
	display: block;
	min-width: 20rem;
	border-radius: 10px;
	overflow: hidden;
	padding: 2rem 1.5rem;
	transition: background-color 0.5s ease-in-out;
	max-width: fit-content;
}

.container__plantiomarker__close {
	color: white;
	font-size: 1rem;
	font-weight: 900;
	-webkit-text-stroke: 0.5px black;
	visibility: visible;
	cursor: pointer;
}

.container__plantiomarker.open > .container__plantiomarker__close {
	visibility: hidden;
	width: 0;
	height: 0;
}

.container__plantiomarker__open {
	display: flex;
	flex-direction: column;
	min-width: 20rem;
	animation: anima__plantiomarker__open 0.75s ease-in-out forwards;
	max-width: 500px;
}
/* 
.container__plantiomarker.open .container__plantiomarker__open {
  display: flex;
  flex-direction: column;
  min-width: 20rem;
  animation: anima__plantiomarker__open 0.75s ease-in-out forwards;
} */

@keyframes anima__plantiomarker__open {
	0%,
	10% {
		opacity: 0;
		transform: translateY(10px);
	}

	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.container__plantiomarker__open__title {
	display: flex;
	font-size: 1.5rem;
	font-weight: 700;
	color: rgb(var(--color-default));
	line-height: 1rem;
}

.container__plantiomarker__open__info {
	display: flex;
	justify-content: space-between;
}

.container__plantiomarker__open__info__values {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.container__plantiomarker__open__info__values.right {
	align-items: flex-end;
}

.container__plantiomarker__open__info__values > span:first-child {
	font-size: 0.75rem;
	color: var(--color-gray-dark);
	font-weight: 500;
}

.container__plantiomarker__open__info__values > span:nth-child(2) {
	font-size: 1.2rem;
	font-weight: 700;
}

.container__plantiomarker__open__info__values > span:nth-child(2) > span:first-child {
	font-size: 0.75rem;
	font-weight: 500;
}

.container__plantiomarker__open__info__values > span:nth-child(3) {
	background-color: rgba(var(--color-default), 0.2);
	color: rgb(var(--color-default));
	padding: 0 0.5rem;
	border-radius: 10px;
	font-weight: 600;
}

.container__plantiomarker__open__info__poligono {
	height: 5rem;
	width: 5rem;
}

.container__plantiomarker__open__info__progress {
	height: 5px;
	width: 100%;
	background-color: rgba(var(--color-rgb-gray), 0.3);
	border-radius: 25px;
	overflow: hidden;
}

.container__plantiomarker__open__info__progress > div {
	height: 5px;
	background-color: rgb(var(--color-default));
}

.button-x {
	background-color: transparent;
	border: none;
	cursor: pointer;
	font-size: 16px;
	position: absolute;
	top: 0.5rem;
	right: 0.5rem;
	z-index: 60;
}
</style>
